import { useEffect, useState } from 'react';
import { Navigate, NavLink, Route, Routes } from 'react-router-dom';
import { SubscribersPage } from './pages/SubscribersPage';
import { ComposePage } from './pages/ComposePage';
import { TemplatesPage } from './pages/TemplatesPage';
import { HistoryPage } from './pages/HistoryPage';
import { SubscriberProfilePage } from './pages/SubscriberProfilePage';
import { SegmentsPage } from './pages/SegmentsPage';
import { applyTheme, getStoredTheme, type Theme } from './lib/theme';

export function App() {
  const [theme, setTheme] = useState<Theme>(getStoredTheme());

  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  function toggleTheme() {
    setTheme((t) => (t === 'dark' ? 'light' : 'dark'));
  }

  return (
    <div className="app-shell">
      <div className="app">
        <header className="brand">
          <h1>Atomic Rose Newsletter</h1>
          <div className="row" style={{ gap: 12 }}>
            <button
              className="theme-toggle"
              onClick={toggleTheme}
              title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`}
              aria-label="Toggle theme"
            >
              {theme === 'dark' ? '☀' : '☾'}
            </button>
            <span className="meta">{new Date().toLocaleDateString()}</span>
          </div>
        </header>

        <nav className="tabs" role="tablist">
          <Tab to="/" label="Subscribers" end />
          <Tab to="/compose" label="Compose" />
          <Tab to="/templates" label="Templates" />
          <Tab to="/segments" label="Segments" />
          <Tab to="/history" label="History" />
        </nav>

        <Routes>
          <Route path="/" element={<SubscribersPage />} />
          <Route path="/compose" element={<ComposePage />} />
          <Route path="/templates" element={<TemplatesPage />} />
          <Route path="/segments" element={<SegmentsPage />} />
          <Route path="/history" element={<HistoryPage />} />
          <Route path="/subscriber/:email" element={<SubscriberProfilePage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </div>
  );
}

function Tab({ to, label, end }: { to: string; label: string; end?: boolean }) {
  return (
    <NavLink
      to={to}
      end={end}
      role="tab"
      className={({ isActive }: { isActive: boolean }) => `tab ${isActive ? 'active' : ''}`}
    >
      {label}
    </NavLink>
  );
}
